// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__V1Hpw","footerContent":"Footer_footerContent__PnIio","column":"Footer_column__k1+MB","social":"Footer_social__YQLZi","bottom":"Footer_bottom__elLxA"};